import filter from "./lib/filter";
import loadmore from "./lib/loadmore";

loadmore();
filter();

const copyButton = document.querySelectorAll(".post__socials-button");

copyButton.forEach((button) => {
  button.addEventListener("click", async () => {
    await navigator.clipboard.writeText(button.dataset.url);
    button.classList.add("is--copied");
    setTimeout(() => {
      button.classList.remove("is--copied");
    }, 2000);
  });
});
